import styles from './destacatlateral.module.scss';
import Enllac from 'components/corporatiu/Enllac';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';

const DestacatLateral = (props) => {
    const { avantitol, titol, text, enllac, fons, estil, tipus } = props;
    const stylesDestacatLateral = clsx({
        [styles.destacatLateral]: true,
        [styles.ambFons]: !__isEmpty(fons),
        [styles[estil]]: !__isEmpty(estil),
        [styles[tipus]]: !__isEmpty(tipus)
    });

    return (
        <aside className={stylesDestacatLateral}>
            <Enllac href={enllac} className={styles.enllac} dataTestId='destacatlateral-enllac'>
                {!__isEmpty(avantitol) && <span className={styles.avantitol}>{avantitol}</span>}
                {!__isEmpty(titol) && <span className={styles.titol}>{titol}</span>}
                {!__isEmpty(text) && <span className={styles.text} dangerouslySetInnerHTML={{ __html: text }}></span>}
            </Enllac>
            {!__isEmpty(fons) && <div className={styles.fons} style={{ backgroundImage: `url(${fons})` }}></div>}
        </aside>
    );
};

export default DestacatLateral;
